import { AxiosDelete } from '../../http/Axios';

const DeleteFamilyByEmail = async (email) => {
  const eml = (email ?? '').trim();
  if (!eml) return false;

  try {
    const res = await AxiosDelete('/kidlab-reg/families/by-email', {
      params: { email: eml },
      validateStatus: s => (s >= 200 && s < 300) || s === 404,
    });

    if (res.status === 404) {
      console.info(`No matching family found for ${eml}`);
      return false;
    }
    return res.status === 204 || res.status === 200;
  } catch (err) {
    if (err?.response?.status === 400) {
      console.warn(`Invalid email: ${eml}`);
      return false;
    }
    console.error('Delete family failed', err);
    throw err;
  }
};


export default DeleteFamilyByEmail;
